export default __webpack_public_path__ + "static/media/charliepuentecv.5a5b57f7.pdf";